export enum IndicatorUpdatesSortOptions {
  Due_Most_Recent = 1,
  Due_Oldest = 2,
  Due_Earliest = 3,
  Due_Latest = 4,
  Updated_Recent = 5,
  Updated_Oldest = 6,
}
